import { Box, Icon, Text, VStack } from "@chakra-ui/react";
import { StatusHistory } from "../../../api/types";
import timestampDisplay from "../../../utils/timestampDisplay";
import { typedSxMap } from "../../../utils/typedSxMap";
import { PiCheckCircle, PiFileArrowUp, PiPlayCircle, PiQuestion, PiTreeStructure } from "react-icons/pi";

export enum TimelineType {
  IMPORT_COMPLETE = "complete",
  IMPORT_IMPORTING = "importing",
  IMPORT_UPLOADING = "uploading",
  IMPORT_REVIEW = "review",
}

const ICONS = {
  [TimelineType.IMPORT_COMPLETE]: PiCheckCircle,
  [TimelineType.IMPORT_IMPORTING]: PiPlayCircle,
  [TimelineType.IMPORT_REVIEW]: PiTreeStructure,
  [TimelineType.IMPORT_UPLOADING]: PiFileArrowUp,
};

const defaultIcon = PiQuestion;

const styles = typedSxMap({
  timeline: {
    display: "flex",
    flexDirection: "column",
    gap: "var(--m)",
  },
  timelineItem: {
    pl: 4,
    ml: 2,
    position: "relative",
    _before: {
      content: '""',
      position: "absolute",
      top: "32px",
      left: "1px",
      height: "60%",
      width: "1px",
      backgroundColor: "var(--color-text-soft)",
    },
    "& > p": {
      marginBottom: 0,
    },
    "&:last-of-type": {
      "&:before": {
        display: "none",
      },
    },
  },
  timelineIcon: {
    position: "absolute",
    left: "-10px",
    top: "0",
    padding: "2px",
    width: "24px",
    height: "24px",
    color: "var(--color-text-soft)",
  },
  date: {
    color: "var(--color-text-soft)",
  },
});

type OverviewTimelineProps = {
  timelineData: StatusHistory[];
};

function TimelineItem({ status, time, message }: StatusHistory) {
  return (
    <Box sx={styles.timelineItem}>
      <Icon as={ICONS[status as TimelineType] || defaultIcon} sx={styles.timelineIcon} />
      <Text>{message}</Text>
      <Text sx={styles.date}>{timestampDisplay(time)}</Text>
    </Box>
  );
}

export default function OverviewTimeline({ timelineData }: OverviewTimelineProps) {
  timelineData.sort((a, b) => b.time - a.time);

  return (
    <VStack align="start" sx={styles.timeline}>
      {timelineData.map((item, index) => (
        <TimelineItem key={index} {...item} />
      ))}
    </VStack>
  );
}
